import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetAuditLogsRPC } from "./getAuditLogsRPC";

export class GetAuditLogsRPCClientImpl extends GetAuditLogsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetAuditLogsRPC.Request): Promise<LeoRPCResult<GetAuditLogsRPC.Response, GetAuditLogsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "audit-logs/GetAuditLogs",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetAuditLogsRPC.ResponseDTO,
      GetAuditLogsRPC.Errors.ErrorsDTO,
      GetAuditLogsRPC.Response,
      GetAuditLogsRPC.Errors.Errors
    >(
      response,
      "audit-logs/GetAuditLogs",
      GetAuditLogsRPC.Response.fromDTO,
      GetAuditLogsRPC.Errors.fromDTO
    );
  }
}
